import { createApi } from "@reduxjs/toolkit/query/react";
import { BASE_URL, PATHS } from "../../utils/constants";
import HeaderService from "../../services/headerService";
import { createAuthenticatedBaseQuery } from "./authenticatedBaseQuery";

const headerService = new HeaderService();

export const handleApiError = (error) => {
  if (error?.status === 403) {
    window.location.replace(PATHS.forbidden.url);
  }
  return error;
};

const baseQueryWithErrorHandling = createAuthenticatedBaseQuery({
  baseUrl: BASE_URL,
  getHeaders: () => headerService.getAllHeaders(),
  maxGatewayRetries: 2,
  handleError: handleApiError,
});

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithErrorHandling,
  endpoints: () => ({}),
});
